import React from 'react';
import { Card, Form, Input, Button, Avatar, Space, Typography, Divider } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../hooks/useAuthStore';
import { getRoleDisplayName, getRoleColor } from '@shared/utils';

const { Title, Text } = Typography;

const ProfilePage: React.FC = () => {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div>
      <Title level={2}>👤 Profil Ayarları</Title>
      
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        {/* User Info Card */}
        <Card title="Kullanıcı Bilgileri">
          <Space size="middle">
            <Avatar
              size={64}
              style={{
                backgroundColor: getRoleColor(user.role),
                color: 'white'
              }}
              icon={<UserOutlined />}
            />
            <div>
              <Title level={4} style={{ margin: 0 }}>
                {user.username}
              </Title>
              <Text type="secondary">{user.email}</Text>
              <br />
              <Text style={{ color: getRoleColor(user.role) }}>
                {getRoleDisplayName(user.role)}
              </Text>
            </div>
          </Space>
        </Card>

        {/* Password Change Card */}
        <Card title="Şifre Değiştir">
          <Form layout="vertical" style={{ maxWidth: 400 }}>
            <Form.Item
              label="Mevcut Şifre"
              name="currentPassword"
              rules={[{ required: true, message: 'Mevcut şifrenizi girin!' }]}
            >
              <Input.Password prefix={<LockOutlined />} />
            </Form.Item>
            
            <Form.Item
              label="Yeni Şifre"
              name="newPassword"
              rules={[
                { required: true, message: 'Yeni şifrenizi girin!' },
                { min: 8, message: 'Şifre en az 8 karakter olmalı!' }
              ]}
            >
              <Input.Password prefix={<LockOutlined />} />
            </Form.Item>
            
            <Form.Item
              label="Yeni Şifre (Tekrar)"
              name="confirmPassword"
              dependencies={['newPassword']}
              rules={[
                { required: true, message: 'Şifrenizi tekrar girin!' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Şifreler eşleşmiyor!'));
                  },
                }),
              ]}
            >
              <Input.Password prefix={<LockOutlined />} />
            </Form.Item>
            
            <Form.Item>
              <Button type="primary">
                Şifreyi Değiştir
              </Button>
            </Form.Item>
          </Form>
        </Card>

        {/* Permissions Card */}
        <Card title="Yetkilerin">
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {user.permissions.map(permission => (
              <span
                key={permission}
                style={{
                  background: '#f0f0f0',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  color: '#666'
                }}
              >
                {permission}
              </span>
            ))}
          </div>
        </Card>
      </Space>
    </div>
  );
};

export default ProfilePage;
